import { useTranslation } from 'react-i18next'
import { imageUrl } from 'app/frontend/base/helpers'
import { RaidPlanAssignmentType } from 'app/frontend/types/custom/RaidPlan'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import {
  getAssignmentTypeDispelType,
  getEffectiveAssignmentType,
  isAreaControlAssignmentType,
  isImmunityAssignmentType,
} from './assignmentTimeline'

type Props = {
  assignmentType?: RaidPlanAssignmentType
}

const ASSIGNMENT_TYPE_LABEL_KEY: Record<
  Exclude<RaidPlanAssignmentType, 'general' | 'general_assignment'>,
  string
> = {
  immunity: 'immunity',
  mobile_immunity: 'mobile-immunity',
  area_control: 'area-control',
  interrupt: 'interrupt',
  ranged_interrupt: 'ranged-interrupt',
  melee_interrupt: 'melee-interrupt',
  magic_dispel: 'magic-dispel',
  poison_dispel: 'poison-dispel',
  curse_dispel: 'curse-dispel',
  disease_dispel: 'disease-dispel',
}

const AssignmentTypeIcon = ({ assignmentType }: Props) => {
  const { t } = useTranslation()
  const effectiveType = getEffectiveAssignmentType(assignmentType)
  if (effectiveType === 'general' || effectiveType === 'general_assignment') {
    return null
  }
  const isImmunity = isImmunityAssignmentType(effectiveType)
  const isAreaControl = isAreaControlAssignmentType(effectiveType)
  const dispelType = getAssignmentTypeDispelType(effectiveType)
  const label = t(
    `dashboard.team.plans.assignments.assignment-types.${ASSIGNMENT_TYPE_LABEL_KEY[effectiveType]}`,
  )

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        {isImmunity ? (
          <img
            src={imageUrl('icons/642.jpg')}
            alt={label}
            className='w-5 h-5 shrink-0 rounded-full border border-border object-cover'
          />
        ) : isAreaControl ? (
          <img
            src={imageUrl('icons/8122.jpg')}
            alt={label}
            className='w-5 h-5 shrink-0 rounded-full border border-border object-cover'
          />
        ) : dispelType ? (
          <img
            src={imageUrl(`ej-icons/${dispelType}_icon.png`)}
            alt={label}
            className='w-5 h-5 shrink-0'
          />
        ) : (
          <img
            src={imageUrl('ej-icons/interrupt_icon.png')}
            alt={label}
            className='w-5 h-5 shrink-0'
          />
        )}
      </TooltipTrigger>
      <TooltipContent className='text-sm pointer-events-none'>
        {label}
      </TooltipContent>
    </Tooltip>
  )
}

export default AssignmentTypeIcon
